import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="container-x mt-6">
      <ol className="flex flex-wrap items-center gap-1 text-sm text-[color:var(--ft-dim)]">
        {items.map((it, idx) => (
          <li key={it.path} className="flex items-center gap-1">
            {idx > 0 && <ChevronRight size={14} className="opacity-50" />}
            {idx < items.length - 1 ? (
              <Link to={it.path} className="hover:text-[color:var(--ft-text)]">{it.name}</Link>
            ) : (
              <span className="text-[color:var(--ft-muted)]">{it.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
